import {
  Button,
  Container,
  LoadingOverlay,
  Modal,
  ScrollArea,
  Table,
} from "@mantine/core";
import "./Grade.css";
import { randomId } from "@mantine/hooks";
import { useEffect, useState } from "react";
import Grade from "./Grade";
import Toast from "./../Toast";
import { fetchSubmissionsApi } from "./../../api/tasks";

async function fetchSubmissions() {
  const res = await fetchSubmissionsApi().catch((err) => {
    Toast(
      "ERROR",
      err.response != null
        ? err.response.data != null
          ? err.response.data.message != null
            ? err.response.data.message
            : err.message
          : err.message
        : err.message,
      "red"
    );
    if (err.response.status == 401 || err.response.status == 403) {
      localStorage.clear();
      window.location.replace("/");
    }
  });
  if (res == null) return [];
  if (res.status == 200) {
    return res.data;
  } else {
    Toast("ERROR", res.data.message, "red");
    return [];
  }
}

export default function Submission() {
  const [opened, setOpened] = useState(false);
  const [sub, setsub] = useState([]);
  const [subLoad, setsubLoad] = useState(true);
  const [fetchAgain, setfetchAgain] = useState(true);
  const [isChanged, setisChanged] = useState(false);

  useEffect(() => {
    fetchSubmissions().then((res) => {
      setsub(res);
      setsubLoad(false);
    });
  }, [fetchAgain]);
  const [submission, setSubmission] = useState({
    id: 0,
    userId: 0,
    taskNo: 0,
    subAllowed: true,
    showResult: false,
    domain: "",
    submission: {
      id: 0,
      createdAt: "",
      updatedAt: "",
      link: "",
      content: "",
      fileName: "",
      marks: 0,
      penalty: 0,
      remarks: "",
    },
  });
  let rows = [];
  if (sub.submissions != null) {
    sub.submissions.map((mentee) => {
      mentee.tasks.map((submission) => {
        submission.domain = mentee.domain;
        rows.push(
          <tr key={randomId()}>
            <td>{mentee.roll}</td>
            <td>{mentee.name}</td>
            <td>{mentee.domain}</td>
            <td>{submission.taskNo}</td>
            <td>{submission.submission != null ? "Yes" : "No"}</td>
            <td>
              <Button
                style={{
                  display: submission.submission != null ? "inline" : "none",
                }}
                gradient={{ from: "#0063F8", to: "#3391FF" }}
                variant="gradient"
                onClick={() => {
                  setOpened(true);
                  submission.userId = mentee.id;
                  setSubmission(submission);
                }}
              >
                {submission.submission != null
                  ? submission.subAllowed || submission.showResult
                    ? "View"
                    : submission.submission.marks != null
                    ? "Update"
                    : " Add  "
                  : ""}
              </Button>
            </td>
          </tr>
        );
      });
    });
  }
  return (
    <>
      <Modal
        centered
        size="90%"
        opened={opened}
        onClose={() => {
          if (isChanged == true) {
            setisChanged(false);
            setsubLoad(true);
            setfetchAgain(!fetchAgain);
          }
          setOpened(false);
        }}
      >
        <Grade submission={submission} isChange={setisChanged} />
      </Modal>
      <Container style={{ width: "100%" }}>
        <h2 style={{ textAlign: "center" }}>Submissions</h2>
        <div
          style={{
            marginTop: "15px",
            borderRadius: "5px",
            overflow: "auto",
            position: "relative",
            width: "100%",
          }}
        >
          <LoadingOverlay visible={subLoad} />
          <ScrollArea style={{ height: "540px" }}>
            <Table
              highlightOnHover
              horizontalSpacing="md"
              verticalSpacing="xs"
              fontSize="md"
              striped
            >
              <thead>
                <tr
                  style={{
                    backgroundColor: "#0063F8",
                    textAlign: "center",
                  }}
                >
                  <th style={{ color: "white", textAlign: "center" }}>
                    Roll No
                  </th>
                  <th style={{ color: "white", textAlign: "center" }}>Name</th>
                  <th style={{ color: "white", textAlign: "center" }}>
                    Domain
                  </th>
                  <th style={{ color: "w  hite", textAlign: "center" }}>Task</th>
                  <th style={{ color: "white", textAlign: "center" }}>
                    Submitted
                  </th>
                  <th style={{ color: "white", textAlign: "center" }}>View</th>
                  {/* <th style={{ color: "white", textAlign: "center" }}>Grade</th> */}
                </tr>
              </thead>
              <tbody>{rows}</tbody>
            </Table>
          </ScrollArea>
        </div>
      </Container>
    </>
  );
}
